import { render, staticRenderFns } from "./ViewConfig.vue?vue&type=template&id=7e206146&scoped=true&"
import script from "./ViewConfig.vue?vue&type=script&lang=js&"
export * from "./ViewConfig.vue?vue&type=script&lang=js&"
import style0 from "./ViewConfig.vue?vue&type=style&index=0&id=7e206146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e206146",
  null
  
)

export default component.exports